import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent implements OnInit {
  rapidUserList: Subscription;
  contactId: string;
  fullName: string;
  emailAddress: string;
  agencyName: string;
  collectorStatus: string;
  contactLayout: string;
  rapidSelected:string;
  validationErrors:string[]=[];
  isError:boolean=false;

  platform =['lmc','rapid'];
  companyNames:any;
  companySelectedData:string[]=[];
  departmentNames:any;
  departmentSelectedData:[];
  roles=[
    {value:11,displayName:'Standard'},
    {value:1,displayName:'Manager'},
    {value:10,displayName:'Department Head'}
  ]

  contact_form = new FormGroup({
    fullName: new FormControl('', Validators.required),
    emailAddress: new FormControl('', Validators.required),
    role: new FormControl('', Validators.required),
    agency: new FormControl('', Validators.required),
    department: new FormControl('', Validators.required),
    tempPassword: new FormControl(false)
  })

  public gridApi_contact: any;
  public gridApi_contact_data: any;
  public gridColumnApi_contact: any;

  contactData: any;

  defaultColDef_contact: any;
  public columnDefs_contact = [];
  showLoader: boolean;

  constructor(private apiService: LegacyApiService){
    this.getCompanyNames();
    this.columnDefs_contact = [
      { headerName: '', field: '', pinned: 'left',minWidth: 50, filter: false, checkboxSelection:true  },
      { headerName: 'Collector', field: 'Collector', filter: "agTextColumnFilter", minWidth: 250 },
      { headerName: 'Email', field: 'Email', filter: "agTextColumnFilter", minWidth: 250 },
      { headerName: 'Agency', field: 'Agency', filter: "agTextColumnFilter", minWidth: 350 },
      { headerName: 'Role', field: 'Role', filter: "agTextColumnFilter", minWidth: 100 },
    ];
    this.defaultColDef_contact = {
      resizable: true
    };
  };

  ngOnInit(): void {
    let URI = window.location.href
    let decoded = decodeURI(URI)//URI//testing_url
    const urlParams = new URLSearchParams(decoded);
    if(urlParams.get('Account')==='rapid'){
      console.log("Create Rapid account from ZOHO Contacts.")
      this.contactId = urlParams.get('Contact_ID');
      this.fullName = urlParams.get('FirstName').trim().concat(' ').concat(urlParams.get('LastName')).trim();
      // this.emailAddress = urlParams.get('Email').trim();
      this.collectorStatus = urlParams.get('CollectorStatus');
      this.contactLayout = urlParams.get('Layout');
      this.rapidSelected = urlParams.get('Rapid');;
      this.agencyName = urlParams.get('Agency_ID');
      if(validateName(this.fullName)) this.validationErrors.push("Remove the word INACTIVE from name.");
      if(this.contactLayout.toLowerCase() !== 'collector') this.validationErrors.push("Please select layout as Collector.");
      if(this.rapidSelected !== 'true') this.validationErrors.push("Please select Rapid under SYSTEM INFORMATION on Contact.");
      if(this.collectorStatus.toLowerCase() !== 'active') this.validationErrors.push("Please select Collector Status as Active.");
    }else{
      console.log("Create account from lmc.")
    }
  }
  async ngAfterViewInit(): Promise<void> {
    const userExist = await this.validateDbUser(this.contactId) ;
    if(userExist) this.validationErrors.push("User exist on the database.");
    this.isError = this.validationErrors.length > 0 ? true : false;
    this.contact_form.patchValue({
      fullName: this.fullName,
      emailAddress: this.emailAddress
    })
    this.loadRapidAccounts();
  }

  getCompanyNames(){
    this.apiService.getCompanyNames().subscribe((res)=>{
      this.companyNames=res;
    })
  }

  getCompanyData(e:any){
    this.companySelectedData= this.companyNames.filter((item)=>item.company_id === e.value);
    this.apiService.getDepartmentNames(e.value).subscribe((res)=>{
      this.departmentNames = res;
    })
  }

  validateDbUser(collectorZohoId:string){
    return new Promise((resolve,reject)=>{
      this.apiService.validateDbUser(collectorZohoId).subscribe((res)=>{
        resolve(res);
      })
    })
  }

  createAccount(){
    const companyDetails = Object.entries(this.companySelectedData)[0][1];
    let collectorInfo = [{
      email_address: this.contact_form.get('emailAddress').value,
      role_id: this.contact_form.get('role').value,
      full_name: this.contact_form.get('fullName').value,
      company_id: this.contact_form.get('agency').value,
      agency_zoho_id: companyDetails['agency_zoho_id'],
      agency_name: companyDetails['company_name'],
      department_id: this.contact_form.get('department').value,
      collector_zoho_id: this.contactId,
      temporary_password: this.contact_form.get('tempPassword').value
    }];
    this.apiService.createRapidContacts(collectorInfo).subscribe((res)=>{
      this.loadRapidAccounts();
      this.contact_form.reset();
    })
  }

  loadRapidAccounts(){
    this.rapidUserList = this.apiService.loadRapidAccounts().subscribe((res)=>
    {
        this.contactData= res;
        this.gridApi_contact?.setRowData(this.contactData);
        this.gridApi_contact_data = this.contactData;
    })
  }

  onGridReady(params: any): void {
    this.gridApi_contact = params.api;
    this.showLoader = true;
    this.gridColumnApi_contact = params.columnApi;
    this.gridApi_contact?.setRowData(this.contactData);
    this.gridApi_contact_data = this.contactData;
  }

  emailSelectedRows(){
    let selectedRows = this.gridApi_contact.getSelectedRows();
    if(selectedRows.length === 0){
      alert("Please select the user accounts!");
    }else{
      this.apiService.emailRapidAccounts(selectedRows).subscribe(res=>{
      })
    }
  }

  ngOnDestroy(){
    this.rapidUserList.unsubscribe();
  }
}

const validateName = (words:string)=>{
  const searchterm = new RegExp(`\\binactive\\b`,'gi');
  return (searchterm.test(words.toLowerCase()));
}


